import { isBefore, max } from 'date-fns';
import type { ComponentProps } from 'react';
import { DateInput, type DatePickerDateType, getDatePickerDateType, getDateType } from 'ui';

type InputP = ComponentProps<typeof DateInput>['input'];

type ItemP = {
  label?: ComponentProps<typeof DateInput>['item']['label'];
  name: ComponentProps<typeof DateInput>['item']['name'];
  rules: ComponentProps<typeof DateInput>['item']['rules'];
};

type P = {
  input?: InputP;
  item: ItemP;
};

const EventPublish = ({ input, item }: P) => {
  const now = new Date();
  const minimum = input?.minimum ? max([now, input.minimum]) : now;

  return (
    <DateInput
      input={{
        showTime: true,
        ...input,
        minimum,
      }}
      item={{
        getValueFromEvent(event: DatePickerDateType): DatePickerDateType {
          if (isBefore(getDateType(event), minimum)) {
            return getDatePickerDateType(minimum);
          }

          return event;
        },
        ...item,
      }}
    />
  );
};

export default EventPublish;
